import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { plotBackground } from "../../../config/colors";
import { useDate } from "../../../hooks/useDate";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";

export default function PerfilClarificador() {
  const initialFetch = new TostadorFetching().setIdSeccion(2).setSecuencia(43);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  const [corrienteRastraClarificador, setCorrienteRastraClarificador] =
    useState(defaultObject);
  const [torqueClarificadorRake, setTorqueClarificadorRake] =
    useState(defaultObject);
  const [presionClarificador, setPresionClarificador] = useState(defaultObject);
  const [posicionRakeClarificador, setPosicionRakeClarificador] =
    useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      populateTorqueClarificadorRake(data);
      populateCorrienteRastraClarificador(data);
      populatePresionClarificador(data);
      populatePosicionRakeClarificador(data);
      setDateHook(data, "Corriente Rastra Clarificador");
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populatePosicionRakeClarificador(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Posición Rake Clarificador"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setPosicionRakeClarificador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteRastraClarificador(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Rastra Clarificador"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteRastraClarificador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTorqueClarificadorRake(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Torque Clarificador Rake"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTorqueClarificadorRake({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePresionClarificador(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Presión Clarificador"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setPresionClarificador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Clarificador"}
            subtitle={"Periodo " + fullDate()}
          >
            {/** -------------------------------- Corriente Rastra Clarificador --------------------------------------- */}
            <Chart.Line
              name="Corriente Rastra Clarificador"
              data={corrienteRastraClarificador.value}
              yAxis={0}
            />

            {/** -------------------------------- Torque Clarificador Rake --------------------------------------- */}
            <Chart.Line
              name="Torque Clarificador Rake"
              data={torqueClarificadorRake.value}
              yAxis={0}
            />

            {/** -------------------------------- Posición Rake Clarificador --------------------------------------- */}
            <Chart.Line
              name="Posición Rake Clarificador"
              data={posicionRakeClarificador.value}
              yAxis={0}
            />

            {/** -------------------------------- Presión Clarificador --------------------------------------- */}
            <Chart.Line
              name="Presión Clarificador"
              data={presionClarificador.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={corrienteRastraClarificador.fecha} />

            <Chart.YAxis
              labelSuffix=""
              title="Corriente, A - Torque, Nm - Posición, 0 - 1"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={25}
            />

            <Chart.YAxis
              labelSuffix=" kPa"
              title="Presión"
              lineWidth={2}
              lineColor="white"
              opposite={true}
              min={0}
              max={250}
            />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
